var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { QuestionAssociate } from '../../../../questiontype/Associate/QuestionAssociate';
import { AbfragerAssociateAssociationButton } from './AbfragerAssociateAssociationButton';
import { AvailableTooltip } from '../../../../components/other/AvailableTooltip';
let AbfragerAssociateQuestionPart = class AbfragerAssociateQuestionPart extends React.PureComponent {
    render() {
        const { question } = this.props;
        if (!(question instanceof QuestionAssociate))
            return null;
        if (!question.currentAssociation)
            return null;
        return (React.createElement("div", { "data-aspect": "association", style: {
                flex: '1 1 auto',
                display: 'flex',
                paddingLeft: 25,
                paddingTop: 4,
                paddingRight: 10,
                paddingBottom: 0,
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(AvailableTooltip, { placement: "top", title: "Ordne dieses Feld zu" },
                React.createElement("div", null,
                    React.createElement(AbfragerAssociateAssociationButton, { association: question.currentAssociation })))));
    }
};
AbfragerAssociateQuestionPart = __decorate([
    observer
], AbfragerAssociateQuestionPart);
export { AbfragerAssociateQuestionPart };
